// extracted by mini-css-extract-plugin
export default {"cards":"cards_cards__K5gbV"};